import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync';

import { loggedIn } from 'functions.js';
import * as reducers from 'reducers.js';

const appReducer = combineReducers({
  ...reducers
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER') {
    state = {
      configuration: state.configuration,
      ...action.payload
    };
  }
  if (action.type === REHYDRATE) {
    if (action.payload) {
      const { _persist, ...payload } = action.payload;

      state = !loggedIn(payload.tokenExp, payload.tokenExp) ? undefined : payload;
    }
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [] // will not be persisted
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(createStateSyncMiddleware({
      channel: 'dsl_channel',
      whitelist: ['CLEAR_CONFIGURATION', 'CLEAR_CSRF_TOKENS', 'EXTEND_SESSION', 'LOGIN_USER', 'LOGOUT_USER', 'SET_CONFIGURATION', 'SET_CSRF_TOKENS', 'SET_STORE', 'SET_VERIFICATION', 'UPDATE_USER']
    })),
});
initStateWithPrevTab(store);

export const persistor = persistStore(store);
